import { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { getDeviceType } from '@domain-group/fe-brary';
import { initMixpanel } from '@domain-group/fe-helper';
import getEntryPoint from './get-entry-point';
import { clearListingsSearchUtmSourceSuperProperty } from './utils';

const useMixpanel = ({
  mixpanelToken,
  userId,
  sessionId,
}: {
  mixpanelToken: string;
  userId?: string;
  sessionId?: string;
}): boolean => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!mixpanelToken) {
      return undefined;
    }

    initMixpanel(mixpanel, mixpanelToken, {
      userId,
      sessionToken: sessionId,
    });
    // TODO: clean up when utm source is cleansed
    clearListingsSearchUtmSourceSuperProperty(mixpanel);

    mixpanel.register({
      siteSection: 'Agents',
      deviceCategory: getDeviceType(window?.screen?.width),
      entryPoint: getEntryPoint(),
    });

    setIsInitialized(true);

    return () => {
      mixpanel.unregister('entryPoint');
    };
  }, [mixpanelToken, sessionId, userId]);

  return isInitialized;
};

export default useMixpanel;
